export const endPoints = {
  apiBaseUrl: "https://accountapi.bettdraft.com:5000/",

  api: {
    EMAIL_SUPPORT: "crescenthomes/support",
    EMAIL_SUPPORT_DOON: "crescenthomes/contact",
  },
  mode: "Development",
};


export default {};
